import { FunctionComponent } from 'react';

import { ReactComponent as SortIconInitial } from '../../../assets/icons/icon_sort.svg';
import { ReactComponent as SortIconUp } from '../../../assets/icons/icon_chevron_up.svg';
import { ReactComponent as SortIconDown } from '../../../assets/icons/icon_chevron_down.svg';

import {ClassBuilder} from 'b302-frontend-library';

export enum SortIconState {
  Initial,
  Up = "asc",
  Down = "desc"
}

interface Props {
    state: SortIconState;
    className?: string;
}

const SortIcon: FunctionComponent<Props> = (props) => {
    const className = ClassBuilder.createClass('sort-icon')
        .addIf(props.className, props.className)
        .build();

    switch(props.state) {
      case SortIconState.Initial:
        return (<SortIconInitial className={className} />);
      case SortIconState.Up:
        return (<SortIconUp className={className} />);
      case SortIconState.Down:
        return (<SortIconDown className={className} />);
    }
};

export default SortIcon;
